function JobTitle({ value, handleValue }) {
   return (
      <div className="group">
         <label htmlFor="jobtitle">Job Title</label>
         <input
            type="text"
            id="jobtitle"
            autoComplete="off"
            placeholder="e.g. Full Stack Developer"
            value={value ?? ''}
            onChange={e => handleValue(e.target.value, 'jobtitle')}
         />
      </div>
   )
}

export default JobTitle
